module.exports = __webpack_public_path__ + "static/media/Swap.21d2f1df.svg";